import Button, * as Btn from '@lib/components/Button';
import ListItem from '@lib/components/ListItem';
import Menu from '@lib/components/Menu';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { HomeProps } from '@lib/containers/Home';
import * as React from 'react';
import { INativeWindow, ISite } from 'types';
import './Home.css';

declare var Waves: any;

interface IHomeState {
  showMenu: boolean;
  showTrash: boolean;
  showPencil: boolean;
}

class Home extends React.Component<HomeProps, IHomeState> {

  public constructor(props: HomeProps) {
    super(props);
    this.state = { showMenu: false, showPencil: false, showTrash: false };
  }

  public onTokenRetrieved(token: string) {
    this.props.onTokenRetrieved(token);
    (window as INativeWindow).FirebasePlugin.hasPermission((data: any) => {
      if (!data.isEnabled) {
        (window as INativeWindow).FirebasePlugin.grantPermission();
      }
    });
  }

  public componentDidMount() {
    Waves.attach('div.listItem', 'waves-light');
    (window as INativeWindow).FirebasePlugin.getToken(this.onTokenRetrieved.bind(this), (error: any) => {
      alert(error);
    });
    // Reset badge
    (window as INativeWindow).FirebasePlugin.setBadgeNumber(0);
  }

  /**
   * Fired when user clicks on an item 
   * @param state 
   * @param event 
   */
  public onItemClick(item: string, name: string, event: React.MouseEvent<HTMLDivElement>) {
    if (this.state.showTrash && item !== 'add') {
      // It's a deletion
      if (confirm(this.props.i18n.Home.confirmDelete)) {
        this.props.onSiteDelete(item);
      }
    } else if (this.state.showPencil && item !== 'add') {
      // It's an edition
      this.props.onSiteEdit(item, name);
    }
    else {
      if (item === 'add') {
        document.location.hash = 'siteAdd';
      } else {
        this.props.onSelect(item, name);
      }
    }
  }

  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    this.setState({ showMenu: !this.state.showMenu });
  }



  /**
   * Fired when user click on Trash bottom button
   * @param event 
   */
  public onTrashClick(event: React.MouseEvent<HTMLDivElement>) {
    this.setState({ showPencil: false, showTrash: !this.state.showTrash });
  }


  /**
   * Fired when user click on Pencil bottom button
   * @param event 
   */
  public onPencilClick(event: React.MouseEvent<HTMLDivElement>) {
    this.setState({ showPencil: !this.state.showPencil, showTrash: false });
  }



  /**
   * Fired when user click on menu push item
   * @param event 
   */
  public onPushClick(state: any, s: any, event: React.MouseEvent<HTMLDivElement>) {
    // Call API
    event.stopPropagation();
    this.props.onPushClick(!this.props.push, this.props.token);
  }



  /**
   * Fired when user click on menu help item
   * @param event 
   */
  public onHelpClick(state: any, event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
    window.open('https://static.smart-tx.io/docs/Documentation.pdf', '_system');
  }

  public render() {

    if (this.props.sites === undefined) {
      window.location.pathname = '/';
      window.location.hash = '';
      return null;
    }

    const i18n = this.props.i18n.Home;

    return (
      <div className="standardPage home">
        <Menu i18n={{ i18n: this.props.i18n }}
          push={this.props.push}
          show={this.state.showMenu}
          mail={this.props.login}
          onASite={false}
          onCloseClick={this.onMenuClick.bind(this, this.state)}
          onHelpClick={this.onHelpClick.bind(this, this.state)}
          onPushClick={this.onPushClick.bind(this, this.state)}
          onSignoutClick={this.props.onGoHome.bind(this, this.state)}
          onChangePasswordClick={this.props.onGoChangePassword.bind(this, this.state)}
          onSiteClick={this.props.onGoSiteList.bind(this, this.state)}
          token={this.props.token}
        />
        <div className="content">
          <TitleBar
            leftIcon={ITitleBar.ICO_BAR}
            onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
            title={i18n.smartremote}
          />
          <div id="siteList">
            {this.props.sites.map((site: ISite) => {
              /*eslint no-unused-expressions: "warning"*/
              let ico = '';
              if (this.state.showTrash) { ico = 'trash'; }
              else if (this.state.showPencil) { ico = 'pencil'; }
              // else if (site.notif !== undefined && site.notif > 0) { ico = 'warningAlarm'; }
              return (
                <ListItem icoClass={ico} title={site.name!} detail={site.device!.mac} notif={site.notif!} key={site.device!._id} onClick={this.onItemClick.bind(this, site.device!._id, site.name)} />
              )
            })}
          </div>
          <Button labelFA='edit' type={Btn.BTN_TYPE_CIRCLE_UP_UP} onClick={this.onPencilClick.bind(this, 'pencil')} />
          <Button labelFA='trash' type={Btn.BTN_TYPE_CIRCLE_UP} onClick={this.onTrashClick.bind(this, 'trash')} />
          <Button labelFA='plus' type={Btn.BTN_TYPE_CIRCLE} onClick={this.onItemClick.bind(this, 'add')} />
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.tsx